import { render, staticRenderFns } from "./ProjectEvent.vue?vue&type=template&id=72592c04&scoped=true&"
import script from "./ProjectEvent.vue?vue&type=script&lang=js&"
export * from "./ProjectEvent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEvent.vue?vue&type=style&index=0&id=72592c04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72592c04",
  null
  
)

export default component.exports